import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FieldArrayType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormlyApiService } from 'src/app/service/formly-api.service';

@Component({
  selector: 'formly-repeat-section',
  template: `
   <div class="mt-3" *ngIf="hide">
  <div class="row">
    <div class="col-md-10">
      <label *ngIf="props.label">
        <span class="label"><em class="fa {{ to.labelIcon || '' }}"></em> {{ props.label }}</span>
        <mat-icon *ngIf="(!props.hasOwnProperty('tooltipType') || props.tooltipType == 'plain') && props['tooltip']"
                  matTooltip="{{ props['tooltip'] }}"
                  class="icon mt-1"
                  matTooltipPosition="right">help</mat-icon>
        <ng-container *ngIf="props.tooltipType == 'html' && props['tooltip']">
          <em class="fas fa-question-circle icon" [ngbTooltip]="htmlContent" #t="ngbTooltip" (click)="t.open(); $event.stopPropagation()" triggers="click:blur" tooltipClass="my-custom-class" placement="right"></em>

          <ng-template #htmlContent class="ml-4">
            <div [innerHTML]="props['tooltip']"></div>
          </ng-template>
        </ng-container>
      </label>
      <p *ngIf="props.description">{{ props.description }}</p>
    </div>
    <div class="col-md-2 d-flex align-items-center justify-content-end" *ngIf="!isHideButtons && !isAddBtn">
      <button class="btn btnS" type="button" (click)="add();labelChange()">
        <span><i class="fas fa-plus-circle"></i> {{'add'|translate}} </span>
      </button>
    </div>
  </div>
  <div *ngFor="let field of field.fieldGroup; let i = index" >
  <div class="border mt-2 p-3 pt-0">
  <div class="text-end mt-2">
    <button [hidden]="i <= 0" class="btn btn-danger" type="button" (click)="remove(i)" *ngIf="!isHideButtons">
      <span> <i class="fas fa-times-circle"></i> {{'remove'|translate}}</span>
    </button>
  </div>
  <formly-field class="col-md-12" [field]="field"></formly-field>
</div>
</div>

</div>


  `,
  styles: [`
    .borderClass {
      border: 1px solid black;
      border-radius: 25px;
      margin: 10px 0px;
      padding-bottom:15px;
    }
    .label{
      font-size: 16px;
    color: rgba(0, 0, 0, 0.54);
    }
    .btnS{
      background-color: #f15e55 !important;
      color:white;
    }
    .icon {
            font-size: 14px;
            margin-left:5px;
            color: #817c7c;
        }
        .my-custom-class .tooltip-inner {
      max-width: 300px;
      background-color:#DFDFDF;
      font-size: 14px;
      margin-left: 5px;
      color:black !important;
    }
    .my-custom-class .arrow::before {
      border-top-color: #7e7a7a;
    }
    .tooltip .tooltip-arrow {
        margin-left: 5px
    }
  `],
  standalone:true,
  imports:[
    TranslateModule,MatTabsModule,MatFormFieldModule,CommonModule,FormlyModule,MatTooltipModule,MatIconModule,
    NgbTooltipModule
  ]
})
export class RepeatTypeComponent extends FieldArrayType implements OnInit {
  hide: boolean = true;
  hideName:any;
  hideValue:any;
  controlArray:any;
  arrayControls:any;
  isHideButtons: boolean = false;
  isAddBtn: boolean = false;
  fields: FormlyFieldConfig[] = [];
  constructor(private formlyApiService: FormlyApiService,private translate: TranslateService){
    super();
  }
  labelChange(){
    this.fields[0].fieldGroup?.forEach((currentfields: any) => {
      if (currentfields.type == 'repeat') {
        currentfields.fieldGroup.forEach((faField: any, index: number) => {
          faField.fieldGroup.forEach((b: any) => {
            this.formlyApiService.translatePart(b);
          })
        })
      }
    });
  }
  ngOnInit(): void {
    this.fields=this.formlyApiService.getdata();
    this.controlArray=this.field?.key;
    let fieldItems = JSON.parse(JSON.stringify(this.field));
    // console.log(fieldItems)
    this.isHideButtons =  fieldItems.isView ? fieldItems.isView : false;
    this.isAddBtn = fieldItems?.props?.isAddBtn
    // console.log(this.isAddBtn)
    if (this.field?.fieldGroup?.length === 0) {
      // Pushing a default field group if none is initialized.
      this.add(); // this uses the existing 'add' method of FieldArrayType
    } else {
      this.field.fieldGroup?.forEach((field: any) => {
        
        field.fieldGroup.forEach((i: any) => {
          i.defaultValue = i.formControl.value
        })
      });


    }
    if(this.field?.props?.hasOwnProperty('arrayHide')){
      (this.form.get(this.controlArray) as FormArray).controls.forEach((activityGroup: any) => {
        // Iterate over controls in the FormGroup and clear validators
        Object.keys(activityGroup.controls).forEach(controlName => {
            const control = activityGroup.get(controlName);
            if (control.errors?.required) {
              control.isValidation=true
                control.clearValidators();
                control.updateValueAndValidity(); // Update the value and trigger re-validation
            }
        });    
    });
    // console.log(this.form)
      this.hide=false;
      let data = this.field?.props?.arrayHide;
      let regex = /model\.(\w+)\s*!==\s*'([^']+)'/;
      let matches = regex.exec(data);
      if (matches && matches.length === 3) {
        this.hideName = matches[1];
        this.hideValue = matches[2];
   
    const findData: any = this.fields[0].fieldGroup?.find((a: any) => a['key'] == this.hideName);
    const currentArrayFieldData: any = findData?.key;
    const currentArrayFieldControl = this.form.get(currentArrayFieldData) as FormControl;

    if (currentArrayFieldControl) {
      if(currentArrayFieldControl.value){
        this.valueChages(currentArrayFieldControl.value)
      }
      currentArrayFieldControl.valueChanges.subscribe((selectedValue: any) => {
       this.valueChages(selectedValue)
      });
    }
    
    }
  }
      }

      valueChages(selectedValue:any){
        let value=selectedValue.toString();
        if (value === this.hideValue) {
          this.hide = true;
            // this.arrayControls.push(new FormControl());
            (this.form.get(this.controlArray) as FormArray).controls.forEach((activityGroup: any) => {
              // Iterate over controls in the FormGroup and clear validators
              Object.keys(activityGroup.controls).forEach(controlName => {
                  const control = activityGroup.get(controlName);
                  if (control) {
                      if(control.isValidation){
                        control.isValidation=false
                      control.addValidators(Validators.required)
                      control.updateValueAndValidity(); // Update the value and trigger re-validation
                      }
                  }
              });    
          });
          // }
        } else {
          this.hide = false;
          (this.form.get(this.controlArray) as FormArray).controls.forEach((activityGroup: any) => {
            // Iterate over controls in the FormGroup and clear validators
            Object.keys(activityGroup.controls).forEach(controlName => {
                const control = activityGroup.get(controlName);
                if (control) {
                    if(!control.isValidation){
                      control.isValidation=true
                      control.setValue(null)
                    control.clearValidators();
                    control.updateValueAndValidity(); // Update the value and trigger re-validation
                    }
                }
            });    
        });
        }
      }
      
    }
  
